import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=f0768520&scoped=true"
import script from "./registerDialog.vue?vue&type=script&lang=js"
export * from "./registerDialog.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=f0768520&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0768520",
  null
  
)

export default component.exports